import React, { Component } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { RouterMatcher } from './navigation/routes'
import styled from 'styled-components'
import { Flex } from 'reflexbox'
import Footer from './components/Footer'
import Header from './components/Header'

const MainDiv = styled(Flex)` 
  justify-content: center;
  background-color: white;
`;

interface AppIProps {

}

interface AppIState {
}

class App extends Component<AppIProps, AppIState> {

  render() {
    return <Router>
      <Header />
      <MainDiv>
        {RouterMatcher}
      </MainDiv>
      <Footer />
    </Router>

  }
}

export default App;
